import { CreateUsersUsersRequestDataAttributesProfileAttributesRoleEnum } from '@spazious/client-backoffice';

export const IMPERSONATION_SESSION_QUERY_KEY = 'impersonation-session';
export const IMPERSONATION_BANNER_HEIGHT = 32;
export const SPAZIOUS_ADMIN_ROLE =
  CreateUsersUsersRequestDataAttributesProfileAttributesRoleEnum.NUMBER_1;
